import React from "react";

function TTMMLabelKey() {
  return (
    <div className="hero-key key-accidental key-black">
      <div className="hover-text absolute bottom-2 right-2 text-gray-light opacity-0 text-xl font-semibold italic">
        <h3>Tasty Themes for Mono Myths</h3>
      </div>
    </div>
  );
}

export default TTMMLabelKey;
